import * as collection from '@helpers/collection'
import compose from '@helpers/compose'

export const DEFAULT_OPTION = {
  label: 'Todos',
  value: undefined
}

export const toOption = (value) => ({
  value,
  label: value
})

export const toOptions = (values, option = DEFAULT_OPTION) => {
  return compose(
    collection.unique,
    values => values.map(toOption),
    collection.add({ ...option, ...DEFAULT_OPTION }, 'first')
  )(values)
}



// WEBPACK FOOTER //
// ./src/helpers/options.js